import { render, staticRenderFns } from "./SkeletonTurmaFormLoader.vue?vue&type=template&id=0df34c0b"
import script from "./SkeletonTurmaFormLoader.vue?vue&type=script&lang=js"
export * from "./SkeletonTurmaFormLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports